import React, { useMemo } from 'react'

import { useTranslation } from '@mc/i18n'
import {
  StyledVariable,
  UrgencyHandler,
  ORANGE_GREEN_VARIABLE_NAME,
  type UrgencyEntries,
  type UrgencyVariableKey,
} from '@mc/feature-variables'

import { BOGO_I18N_NAMESPACE } from '../../../i18n'

export type UrgencyCopyProps = {
  fullStop?: boolean
  textKey: UrgencyVariableKey
}

export const UrgencyCopy = ({
  textKey,
  fullStop = false,
}: UrgencyCopyProps) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const urgencyConfig = useMemo(
    () => ({
      urgencyMessage: {
        variableName: ORANGE_GREEN_VARIABLE_NAME,
        variableKey: textKey,
      },
    }),
    [textKey],
  ) as UrgencyEntries

  return (
    <UrgencyHandler config={urgencyConfig}>
      {({ urgencyMessage }) => (
        <>
          <StyledVariable
            text={urgencyMessage}
            defaultCopy={t('urgency.title')}
          />
          {fullStop && '.'}
        </>
      )}
    </UrgencyHandler>
  )
}
